module.exports = __webpack_public_path__ + "media/images/new_home/icon-3-33e4d1c201f2654f58b4691c4e9a38f8.png";